export default axios => ({
  /**
   * Возвращает список участников команды
   *
   * @param id
   * @param pageSize
   * @param currentPage
   * @returns {*}
   */
  members ({ id, pageSize = 10, currentPage = 1 } = {}) {
    const params = {
      pageSize: pageSize,
      pageIndex: currentPage
    }

    return axios.get(`/web/team/get/${id}/members`, { params })
  },
  /**
   * Блокировка команды
   *
   * @param id
   * @returns {*}
   */
  block (id) {
    return axios.post(`/web/team/get/${id}/block`)
  },
  /**
   * Разблокировка команды
   *
   * @param id
   * @returns {*}
   */
  unblock (id) {
    return axios.delete(`/web/team/get/${id}/unblock`)
  }
})
